import { CONFIRMATION_TIME, INACTIVITY_LIMIT } from 'app/config/constants';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

export default function useInactivity() {
  const [showWarning, setShowWarning] = useState(false);
  const navigate = useNavigate();
  let timeout, confirmTimeout;

  const resetTimer = () => {
    clearTimeout(timeout);
    clearTimeout(confirmTimeout);
    setShowWarning(false);

    timeout = setTimeout(() => {
      setShowWarning(true);
      confirmTimeout = setTimeout(() => {
        console.log('Không có phản hồi -> Chuyển hướng hoặc reload!');
        window.location.reload();
      }, CONFIRMATION_TIME);
    }, INACTIVITY_LIMIT);
  };

  useEffect(() => {
    window.addEventListener('mousemove', resetTimer);
    window.addEventListener('keydown', resetTimer);
    window.addEventListener('scroll', resetTimer);
    window.addEventListener('click', resetTimer);

    resetTimer();

    return () => {
      clearTimeout(timeout);
      clearTimeout(confirmTimeout);
      window.removeEventListener('mousemove', resetTimer);
      window.removeEventListener('keydown', resetTimer);
      window.removeEventListener('scroll', resetTimer);
      window.removeEventListener('click', resetTimer);
    };
  }, []);

  return { showWarning, resetTimer };
}
